import tree from "../../../components/tree.vue";
import CheckRemind from "./CheckRemind/CheckRemind.vue"
import CheckAnalysis from "./CheckAnalysis/CheckAnalysis.vue"
import CheckReportForm from "./CheckReportForm/CheckReportForm.vue"


export default {
    name: 'MaintainManagement',
    components: { tree, CheckRemind, CheckAnalysis, CheckReportForm },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            id: '',
            activeName: 'first',
        }
    },
    created() {
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            console.log(item)
            this.orgId = item.id
            if (this.activeName == 'first') {
                this.$refs.TabRemind.orgId = item.id
                this.$refs.TabRemind.getCheckList()
            } 
            else {
                
            }
        },
        nodeClick(val) {
            console.log(val)
            this.orgId = val.label
            if (this.activeName === 'first') {
                this.$refs.TabRemind.orgId = val.label
                this.$refs.TabRemind.getCheckList()
            } else if(this.activeName === 'second') {
                this.$nextTick(() => {
                    this.$refs.TabAnalysis.$refs.changeTime.orgId = val.label
                    this.$refs.TabAnalysis.$refs.changeTime.getCheckRate()
                    this.$refs.TabAnalysis.$refs.changeTime.getStateRate()
                    this.$refs.TabAnalysis.$refs.changeTime.getMonthOrderList()
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.TabReportForm.orgId = val.label
                    this.$refs.TabReportForm.$refs.monthTime.orgId = val.label
                    this.$refs.TabReportForm.$refs.monthTime.getMonthOrderList()
                })
            }
        },
        handleClick(event) {
            console.log(event)
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.$refs.TabRemind.orgId = this.orgId
                    this.$refs.TabRemind.getCheckList()
                })
            } else if(this.activeName === 'second') {
                this.$nextTick(() => {
                    console.log(this.orgId)
                    this.$refs.TabAnalysis.$refs.changeTime.orgId = this.orgId
                    this.$refs.TabAnalysis.$refs.changeTime.getCheckRate()
                    this.$refs.TabAnalysis.$refs.changeTime.getStateRate()
                    this.$refs.TabAnalysis.$refs.changeTime.getMonthOrderList()
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.TabReportForm.orgId = this.orgId
                    this.$refs.TabReportForm.$refs.monthTime.orgId = this.orgId
                    this.$refs.TabReportForm.$refs.monthTime.getMonthOrderList()
                })
            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}